import { isEmpty } from "lodash";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import AuthProvider from "../../context/AuthContext";
import BetSlipContext from "../../context/BetSlipContext";
import PriceList from "./PriceList";

const Keyboard = ({
  details,
  selectedBet,
  setSlipObj,
  resetSelection,
  slipObj,
  amountRange,
  betType,
}) => {
  let {
    setBetSelectionObj,
    betSelectionObj,
    matchLastOdds,
    handelPlaceBookmakerBet,
    handelPlaceFancyBet,
    handelPlacePreminumFancyBet,
    betLoader,
    defaultStake,
    defaultOdds,
    handelPlaceToss,
    handelPlaceTie,
    setLoaderCount,
    handelPlaceBetfair
  } = useContext(BetSlipContext);
  const navigate = useNavigate();
  let { profileData, user, loader } = useContext(AuthProvider);
  const [messageTab, setMessageTab] = useState(false);
  // Desktop renders the compact betslip as ONE horizontal row
  // (Cancel | odds | stake | Place Bet) with the quick stakes in a single row.
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window !== "undefined" && window.matchMedia("(min-width: 1024px)").matches
  );
  useEffect(() => {
    const media = window.matchMedia("(min-width: 1024px)");
    const update = () => setIsDesktop(media.matches);
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, []);
  useEffect(() => {
    setMessageTab(betSelectionObj?.bidPrice >= amountRange.min ? false : true);
  }, [betSelectionObj?.bidPrice]);
  
  // Don't render if betType is empty (bet was placed or cancelled)
  if (!betSelectionObj?.betType || betSelectionObj?.betType === "") {
    return null;
  }
  // console.log(amountRange)
  // const [showElement, setShowElement] = useState(true);

  // useEffect(() => {
  //   const timer = setTimeout(function () {
  //     setBetSelectionObj({
  //       ...betSelectionObj,
  //       priceToogle: false,
  //     });
  //     resetSelection(betType);
  //   }, 5000);
  //   return () => {
  //     clearTimeout(timer);
  //   };
  //   // setTimeout(function () {
  //   //   setBetSelectionObj({
  //   //     ...betSelectionObj,
  //   //     priceToogle: false,
  //   //     // bidPrice: defaultStake ? defaultStake : "",
  //   //     // expectany: defaultOdds,
  //   //   });
  //   //   // setSlipObj({});
  //   //   resetSelection(betType);
  //   //   // setShowElement(false)
  //   // }, 10000);
  // }, []);

  if (
    betSelectionObj?.betType == "betFair" &&
    matchLastOdds &&
    matchLastOdds?.matchOdds
  ) {
    const selectionId = selectedBet?.selectionId;
    if (betSelectionObj?.layorback == "back") {
      const backObject =
        matchLastOdds &&
        matchLastOdds?.matchOdds?.back &&
        matchLastOdds?.matchOdds?.back.length > 0
          ? matchLastOdds?.matchOdds?.back.find((a) => a.ri == selectionId)
          : {};
      betSelectionObj.oddsSelect = backObject?.rt ? backObject?.rt : "";
    } else if (betSelectionObj?.layorback == "lay") {
      const layObject =
        matchLastOdds &&
        matchLastOdds?.matchOdds?.lay &&
        matchLastOdds?.matchOdds?.lay.length > 0
          ? matchLastOdds?.matchOdds?.lay.find((a) => a.ri == selectionId)
          : {};
      betSelectionObj.oddsSelect = layObject?.rt ? layObject?.rt : "";
    }
  } else if (
    betSelectionObj?.betType == "bookmaker" &&
    matchLastOdds &&
    matchLastOdds?.matchOdds
  ) {
    // console.log(
    //   "betSelectionObj------------",
    //   selectedBet,
    //   matchLastOdds?.matchOdds
    // );
    const selectionId = selectedBet?.teamName;
    if (betSelectionObj?.layorback == "back") {
      const backObject =
        matchLastOdds &&
        matchLastOdds?.matchOdds?.back &&
        matchLastOdds?.matchOdds?.back.length > 0
          ? matchLastOdds?.matchOdds?.back.find((a) => a.name == selectionId)
          : {};
      betSelectionObj.oddsSelect = backObject?.rt ? backObject?.rt : "";
    } else if (betSelectionObj?.layorback == "lay") {
      const layObject =
        matchLastOdds &&
        matchLastOdds?.matchOdds?.lay &&
        matchLastOdds?.matchOdds?.lay.length > 0
          ? matchLastOdds?.matchOdds?.lay.find((a) => a.name == selectionId)
          : {};
      betSelectionObj.oddsSelect = layObject?.rt ? layObject?.rt : "";
    }
  } else if (
    betSelectionObj?.betType == "fancy" &&
    matchLastOdds &&
    matchLastOdds?.fancy
  ) {
    const fancyMid = slipObj?.mi;
    const fancyObject =
      matchLastOdds && matchLastOdds?.fancy && matchLastOdds?.fancy.length > 0
        ? matchLastOdds?.fancy.find((a) => a.mid == fancyMid)
        : {};
    if (betSelectionObj?.layorback == "back") {
      betSelectionObj.oddsSelect =
        fancyObject && fancyObject?.rt && fancyObject.rt.length > 0
          ? fancyObject.rt[1].rt
          : "";
      betSelectionObj.fancyOddSelect =
        fancyObject && fancyObject?.rt && fancyObject.rt.length > 0
          ? fancyObject.rt[1].pt
          : "";
    } else if (betSelectionObj?.layorback == "lay") {
      betSelectionObj.oddsSelect =
        fancyObject.rt && fancyObject.rt.length > 0 ? fancyObject.rt[0].rt : "";
      betSelectionObj.fancyOddSelect =
        fancyObject.rt && fancyObject.rt.length > 0 ? fancyObject.rt[0].pt : "";
    }
  }

  const checkFunc = () => {
    if (
      betSelectionObj?.betType == "betFair" ||
      betSelectionObj?.betType == "bookmaker"
    ) {
      return betSelectionObj?.oddsSelect <= amountRange?.oddsLimit;
    } else {
      return true;
    }
  };
  const disableConditionFunc = () => {
    if (
      betSelectionObj.oddsSelect == "" ||
      betSelectionObj.oddsSelect == null ||
      betLoader ||
      loader ||
      betSelectionObj?.betType == ""
    ) {
      return true;
    } else if (
      betSelectionObj?.bidPrice <= amountRange.max &&
      betSelectionObj?.bidPrice >= amountRange.min &&
      messageTab == false &&
      check
    ) {
      return false;
    } else {
      return false;
    }
  };
  let check = checkFunc();
  let disableCondition = disableConditionFunc();
  const isFancy = betType === "fancy";
  const isBookmaker = betType === "bookmaker";
  const isMatchOdds = betType === "betFair";
  const isCompactSlip = betType === "premiumFancy" || isFancy || isBookmaker || isMatchOdds;
  // On desktop the compact slip becomes a single horizontal row.
  const desktopSlip = isCompactSlip && isDesktop;
  const compactPanelBackground = isBookmaker || isMatchOdds
    ? betSelectionObj?.layorback === "lay" ? "#f2d5dc" : "#bfdef1"
    : isFancy
      ? betSelectionObj?.layorback === "lay" ? "#f2e5e8" : "#dceaf4"
      : compactSlipStyles.panel.background;
  const compactOddsTheme = isBookmaker || isMatchOdds
    ? { background: "#bacbd6", borderColor: "#adc1ce", color: "#46545e" }
    : isFancy
      ? { background: "#ddd", borderColor: "#bbb", color: "#999" }
      : { background: "#bfd0c9", borderColor: "#b4c7ba", color: "#4e5c51" };
  const compactSlipDisabled = disableCondition || !check ||
    !Number.isFinite(Number(betSelectionObj?.bidPrice)) ||
    Number(betSelectionObj?.bidPrice) <= 0 ||
    Number(betSelectionObj?.bidPrice) < amountRange.min ||
    Number(betSelectionObj?.bidPrice) > amountRange.max;
  const setCompactStake = (value) => {
    setBetSelectionObj((current) => ({ ...current, inputType: "price", bidPrice: value }));
  };
  const adjustCompactStake = (step) => {
    setBetSelectionObj((current) => ({
      ...current,
      inputType: "price",
      bidPrice: Math.max(0, Math.round(((Number(current.bidPrice) || 0) + step) * 100) / 100),
    }));
  };

  // Shared cancel + place-bet handlers (used by the desktop row layout and the
  // existing compact/mobile layout).
  const handleCancel = () => {
    setBetSelectionObj({
      priceToogle: false,
      bidPrice: defaultStake ? defaultStake : "",
      expectany: defaultOdds,
    });
    setSlipObj({});
    resetSelection(betType);
  };
  const handlePlaceBet = () => {
    if (isEmpty(user)) { navigate("/login"); return; }
    if (betLoader || loader) return;
    if (betSelectionObj?.betType == "tie" && betSelectionObj?.bidPrice > 0) {
      handelPlaceTie({ ...details, ...selectedBet }); return;
    }
    if (betSelectionObj?.betType == "toss" && betSelectionObj?.bidPrice > 0) {
      handelPlaceToss({ ...details, ...selectedBet }); return;
    }
    if (!(betSelectionObj?.bidPrice <= amountRange.max && betSelectionObj?.bidPrice >= amountRange.min && messageTab == false && check)) return;
    const betDelay = amountRange?.betDelay;
    const setCount = () => setLoaderCount(betDelay > 1 ? betDelay : 1);
    if (betSelectionObj?.betType == "betFair") {
      handelPlaceBetfair({ ...details, ...selectedBet, maxProfit: amountRange.maxProfit, betDelay }); setCount();
    } else if (betSelectionObj.betType == "bookmaker") {
      handelPlaceBookmakerBet({ ...details, ...selectedBet, betDelay }); setCount();
    } else if (betSelectionObj.betType == "fancy") {
      handelPlaceFancyBet({ ...details, ...selectedBet, ...slipObj, betDelay }); setCount();
    } else if (betSelectionObj.betType == "premiumFancy") {
      handelPlacePreminumFancyBet({ ...details, ...slipObj, betDelay }); setCount();
    }
  };

  // ── Desktop: single horizontal row ───────────────────────────────────────
  if (desktopSlip) {
    const oddsText = isFancy
      ? `${betSelectionObj?.oddsSelect}/${betSelectionObj?.fancyOddSelect}`
      : betSelectionObj?.oddsSelect;
    return (
      <div
        aria-label={`${isBookmaker ? "Bookmaker" : isMatchOdds ? "Match Odds" : isFancy ? "Fancy" : "Sportsbook"} betslip`}
        style={{ ...compactSlipStyles.panel, background: compactPanelBackground, gap: "7px", padding: "7px 8px 6px" }}
      >
        <div style={{ ...compactSlipStyles.desktopRow, gap: "8px" }}>
          <a id="cancel" href="javascript:void(0)" onClick={handleCancel} style={compactSlipStyles.desktopCancel}>
            Cancel
          </a>
          <div style={{ ...compactSlipStyles.desktopStepper, pointerEvents: "none" }}>
            <span aria-hidden="true" style={{ ...compactSlipStyles.stepButton, background: "#fff", fontSize: "24px", cursor: "default", pointerEvents: "none", borderRight: "1px solid #aaa" }}>−</span>
            <output aria-label="Selected odds" style={{ ...compactSlipStyles.value, fontSize: "14px", color: "#111", pointerEvents: "none" }}>{oddsText}</output>
            <span aria-hidden="true" style={{ ...compactSlipStyles.stepButton, background: "#fff", fontSize: "24px", cursor: "default", pointerEvents: "none", borderLeft: "1px solid #aaa" }}>+</span>
          </div>
          <div style={compactSlipStyles.desktopStepper}>
            <button type="button" aria-label="Decrease stake" onClick={() => adjustCompactStake(-1)} style={{ ...compactSlipStyles.stepButton, fontSize: "24px", borderRight: "1px solid #aaa" }}>−</button>
            <input
              aria-label="Stake" type="text" inputMode="decimal" autoComplete="off" placeholder="0"
              value={betSelectionObj?.bidPrice ?? ""}
              onFocus={(event) => event.target.select()}
              onChange={(event) => { if (/^\d*(?:\.\d{0,2})?$/.test(event.target.value)) setCompactStake(event.target.value); }}
              style={{ ...compactSlipStyles.value, fontSize: "14px", color: "#111" }}
            />
            <button type="button" aria-label="Increase stake" onClick={() => adjustCompactStake(1)} style={{ ...compactSlipStyles.stepButton, fontSize: "24px", borderLeft: "1px solid #aaa" }}>+</button>
          </div>
          <button
            id="placeBet" onClick={handlePlaceBet} disabled={compactSlipDisabled}
            style={{ ...compactSlipStyles.desktopPlace, cursor: compactSlipDisabled ? "not-allowed" : "pointer", opacity: compactSlipDisabled ? 0.6 : 1 }}
          >
            Place Bet
          </button>
        </div>
        <div style={compactSlipStyles.desktopStakes}>
          {[100, 200, 500, 5000, 10000, 25000, 50000, 100000].map((stake) => (
            <button key={stake} type="button" onClick={() => setCompactStake(stake)} style={compactSlipStyles.desktopStakeButton}>
              {stake}
            </button>
          ))}
        </div>
      </div>
    );
  }

  return (
    <>
      <div
        className={
          isCompactSlip
            ? undefined
            : betSelectionObj?.layorback == "lay"
              ? "bet_slip-wrap lay"
              : "bet_slip-wrap back"
        }
        aria-label={isCompactSlip ? `${isBookmaker ? "Bookmaker" : isMatchOdds ? "Match Odds" : isFancy ? "Fancy" : "Sportsbook"} betslip` : undefined}
        style={isCompactSlip ? { ...compactSlipStyles.panel, background: compactPanelBackground } : undefined}
      >
        {/* <div
              id="messageWrap"
              className="message-wrap"
              style={{
                display: messageTab ? "flex" : "none",
              }}
            >
              <div className="message">
                <h4 id="info" style={{ background: "#184438" }}>
                  The stake you have entered are below the minimum.
                </h4>
              </div>
              <a
                id="close"
                className="close"
                onClick={() => setMessageTab(false)}
                href="javascript:void(0)"
              >
                Close
              </a>
            </div> */}

        {isCompactSlip ? (
          <div style={compactSlipStyles.twoColumns}>
            <div style={{ ...compactSlipStyles.stepper, ...compactOddsTheme }}>
              <button type="button" disabled aria-label="Decrease odds" style={{ ...compactSlipStyles.stepButton, ...compactSlipStyles.disabledStep, borderRight: `1px solid ${compactOddsTheme.borderColor}` }}>−</button>
              <output aria-label="Selected odds" style={{ ...compactSlipStyles.value, color: compactOddsTheme.color, background: "transparent" }}>
                {isFancy
                  ? `${betSelectionObj?.oddsSelect}/${betSelectionObj?.fancyOddSelect}`
                  : betSelectionObj?.oddsSelect}
              </output>
              <button type="button" disabled aria-label="Increase odds" style={{ ...compactSlipStyles.stepButton, ...compactSlipStyles.disabledStep, borderLeft: `1px solid ${compactOddsTheme.borderColor}` }}>+</button>
            </div>
            <div style={compactSlipStyles.stepper}>
              <button type="button" aria-label="Decrease stake" onClick={() => adjustCompactStake(-1)} style={{ ...compactSlipStyles.stepButton, borderRight: "1px solid #aaa" }}>−</button>
              <input
                aria-label="Stake"
                type="text"
                inputMode="decimal"
                autoComplete="off"
                placeholder="0"
                value={betSelectionObj?.bidPrice ?? ""}
                onFocus={(event) => event.target.select()}
                onChange={(event) => {
                  if (/^\d*(?:\.\d{0,2})?$/.test(event.target.value)) {
                    setCompactStake(event.target.value);
                  }
                }}
                style={compactSlipStyles.value}
              />
              <button type="button" aria-label="Increase stake" onClick={() => adjustCompactStake(1)} style={{ ...compactSlipStyles.stepButton, borderLeft: "1px solid #aaa" }}>+</button>
            </div>
          </div>
        ) : (
        <ul className="btn-list">
          <li>
            <p className="dynamic-min-bet">&nbsp;</p>
            <div
              id="inputOdds"
              className={
                betSelectionObj?.betType == "betFair"
                  ? "input-num"
                  : "input-num disable"
              }
            >
              <a
                // id={"odds2"}
                name={betSelectionObj?.oddsSelect}
                id="oddsDown"
                // disabled={betSelectionObj?.betType == "betFair" ? false : true}
                disabled={true}
                className="icon-minus"
                style={{
                  display:
                    betSelectionObj?.betType !== "betFair" ? "none" : "flex",
                }}
                // onClick={() => {
                //   if (betSelectionObj?.betType == "betFair") {
                //     setBetSelectionObj({
                //       ...betSelectionObj,
                //       inputType: "odds",
                //       oddsSelect: Number(
                //         Number(betSelectionObj?.oddsSelect) == 1
                //           ? Number(betSelectionObj?.oddsSelect)
                //           : Number(betSelectionObj?.oddsSelect) - 0.01
                //       ).toFixed(2),
                //     });
                //   }
                // }}
                // onChange={(e) => {
                //   setBetSelectionObj({
                //     ...betSelectionObj,
                //     oddsSelect: Number(e.target.value),
                //   });
                // }}
                href="javascript:void(0)"
              ></a>
              <span
                id="odds"
                className={
                  betSelectionObj?.betType == "betFair"
                    ? betSelectionObj?.inputType == "odds"
                      ? `typeing ${
                          Number(document.getElementById("oddsDown")?.name) !=
                            betSelectionObj?.oddsSelect && "spark"
                        }`
                      : `typed ${
                          Number(document.getElementById("oddsDown")?.name) !=
                            betSelectionObj?.oddsSelect && "spark"
                        }`
                    : `typed ${
                        Number(document.getElementById("oddsDown")?.name) !=
                          betSelectionObj?.oddsSelect && "spark"
                      }`
                }
                // className={
                //   betSelectionObj?.layorback == "lay"
                //     ? `lay-1 select ${
                //         Number(document.getElementById("oddsDown")?.name) !==
                //           betSelectionObj?.oddsSelect && "spark"
                //       }`
                //     : `back-1 ${
                //         Number(document.getElementById("oddsDown")?.name) !==
                //           betSelectionObj?.oddsSelect && "spark"
                //       }`
                // }
              >
                {betSelectionObj?.betType == "fancy"
                  ? `${betSelectionObj?.oddsSelect}/${betSelectionObj?.fancyOddSelect}`
                  : betSelectionObj?.betType !== "betFair"
                  ? betSelectionObj?.oddsSelect
                  : ""}
                {betSelectionObj?.betType == "betFair" && (
                  <input
                    // style={{
                    //   color: `${
                    //     betSelectionObj?.layorback == "lay" ? "#fff" : "#000"
                    //   }`,
                    // }}
                    onFocus={false}
                    type="number"
                    value={betSelectionObj?.oddsSelect}
                    placeholder="Odds"
                    inputmode="none"
                    disabled={true}
                    // onChange={(e) => {
                    //   setBetSelectionObj({
                    //     ...betSelectionObj,
                    //     oddsSelect: Number(e.target.value),
                    //   });
                    // }}
                    // onKeyDown={(event) => {
                    //   event.preventDefault();
                    // }}
                    // onClick={(e) => {
                    //   e.target.blur();
                    //   if (betSelectionObj?.betType == "betFair") {
                    //     setBetSelectionObj({
                    //       ...betSelectionObj,
                    //       inputType:
                    //         betSelectionObj?.betType == "betFair" ? "odds" : "",
                    //       oddsSelect: "",
                    //     });
                    //   }
                    // }}
                  />
                )}
              </span>
              <a
                id="oddsUp"
                className="icon-plus"
                style={{
                  display:
                    betSelectionObj?.betType !== "betFair" ? "none" : "flex",
                }}
                href="javascript:void(0)"
                // disabled={betSelectionObj?.betType == "betFair" ? false : true}
                disabled={true}
                // onClick={() => {
                //   if (betSelectionObj?.betType == "betFair") {
                //     setBetSelectionObj({
                //       ...betSelectionObj,
                //       inputType: "odds",
                //       oddsSelect: Number(
                //         Number(betSelectionObj?.oddsSelect) + 0.01
                //       ).toFixed(2),
                //     });
                //   }
                // }}
              ></a>
            </div>
          </li>
          <li>
            <p className="dynamic-min-bet">
              Min Bet:{" "}
              <strong id="dynamicMinBet">
                {amountRange.min ? amountRange.min : 10}
              </strong>
            </p>

            <div id="inputOdds" className="input-num input-stake">
              <a
                id="stakeDown"
                className="icon-minus"
                onClick={() => {
                  setBetSelectionObj({
                    ...betSelectionObj,
                    inputType: "price",
                    bidPrice: Number(
                      Number(betSelectionObj.bidPrice) == 1
                        ? Number(betSelectionObj.bidPrice)
                        : Number(betSelectionObj.bidPrice) - 1
                    ),
                  });
                  // setBidPrice((prev) =>
                  //   Number(prev) == 1 ? prev : Number(prev) - 1
                  // );
                  // setInputType("price");
                }}
                href="javascript:void(0)"
              ></a>
              <span
                id="stake"
                className={
                  betSelectionObj?.inputType == "price"
                    ? "typed typeing"
                    : "typed"
                }
              >
                <input
                  onFocus={true}
                  type="number"
                  value={betSelectionObj?.bidPrice}
                  // placeholder="Price"
                  // readOnly="readonly"
                  inputmode="none"
                  onChange={(e) => {
                    setBetSelectionObj({
                      ...betSelectionObj,
                      bidPrice: Number(e.target.value),
                    });
                    // setBidPrice(e.target.value);
                  }}
                  onKeyDown={(event) => {
                    event.preventDefault();
                  }}
                  onClick={(e) => {
                    e.target.blur();
                    setBetSelectionObj({
                      ...betSelectionObj,
                      inputType: "price",
                      bidPrice: "",
                    });
                    // setInputType("price");
                    // setBidPrice("");
                  }}
                />
              </span>
              <a
                id="stakeUp"
                className="icon-plus"
                href="javascript:void(0)"
                onClick={() => {
                  setBetSelectionObj({
                    ...betSelectionObj,
                    inputType: "price",
                    bidPrice: Number(Number(betSelectionObj.bidPrice) + 1),
                  });
                  // setBidPrice((prev) => Number(prev) + 1);
                  // setInputType("price");
                }}
              ></a>
            </div>
          </li>
        </ul>
        )}
        {isCompactSlip ? (
          <div style={compactSlipStyles.stakes}>
            {[100, 200, 500, 5000, 10000, 25000, 50000, 100000].map((stake) => (
              <button key={stake} type="button" onClick={() => setCompactStake(stake)} style={compactSlipStyles.stakeButton}>
                {stake}
              </button>
            ))}
          </div>
        ) : (
          <PriceList
            stake={
              profileData?.stake?.length > 0
                ? profileData?.stake
                : profileData?.editStake?.slice(0, 5)
            }
          />
        )}
        <ul className={isCompactSlip ? undefined : "btn-list"} style={isCompactSlip ? compactSlipStyles.actions : undefined}>
          <li style={isCompactSlip ? compactSlipStyles.actionItem : undefined}>
            <a
              id="cancel"
              href="javascript:void(0)"
              onClick={() => {
                setBetSelectionObj({
                  priceToogle: false,
                  bidPrice: defaultStake ? defaultStake : "",
                  expectany: defaultOdds,
                });
                setSlipObj({});
                resetSelection(betType);
              }}
              className={isCompactSlip ? undefined : "btn"}
              style={isCompactSlip ? compactSlipStyles.cancelButton : { display: "block" }}
            >
              Cancel
            </a>
          </li>
          {/* {console.log(betSelectionObj?.betType)} */}
          <li style={isCompactSlip ? compactSlipStyles.actionItem : undefined}>
            <button
              id="placeBet"
              onClick={() => {
                if (!isEmpty(user)) {
                  if (!betLoader && !loader) {
                    if (
                      betSelectionObj?.betType == "tie" &&
                      betSelectionObj?.bidPrice > 0
                    ) {
                      handelPlaceTie({ ...details, ...selectedBet });
                    } else if (
                      betSelectionObj?.betType == "toss" &&
                      betSelectionObj?.bidPrice > 0
                    ) {
                      handelPlaceToss({ ...details, ...selectedBet });
                    } else {
                      if (
                        betSelectionObj?.bidPrice <= amountRange.max &&
                        betSelectionObj?.bidPrice >= amountRange.min &&
                        messageTab == false &&
                        check
                      ) {
                        if (betSelectionObj?.betType == "betFair") {
                          // console.log("button clicked")
                          handelPlaceBetfair({
                            ...details,
                            ...selectedBet,
                            maxProfit: amountRange.maxProfit,
                            betDelay: amountRange?.betDelay,
                          });
                          setLoaderCount(
                            amountRange?.betDelay > 1
                              ? amountRange?.betDelay
                              : 1
                          );
                        } else if (betSelectionObj.betType == "bookmaker") {
                          handelPlaceBookmakerBet({
                            ...details,
                            ...selectedBet,
                            betDelay: amountRange?.betDelay,
                          });
                          setLoaderCount(
                            amountRange?.betDelay > 1
                              ? amountRange?.betDelay
                              : 1
                          );
                        } else if (betSelectionObj.betType == "fancy") {
                          handelPlaceFancyBet({
                            ...details,
                            ...selectedBet,
                            ...slipObj,
                            betDelay: amountRange?.betDelay,
                          });
                          setLoaderCount(
                            amountRange?.betDelay > 1
                              ? amountRange?.betDelay
                              : 1
                          );
                        } else if (betSelectionObj.betType == "premiumFancy") {
                          handelPlacePreminumFancyBet({
                            ...details,
                            ...slipObj,
                            betDelay: amountRange?.betDelay,
                          });
                          setLoaderCount(
                            amountRange?.betDelay > 1
                              ? amountRange?.betDelay
                              : 1
                          );
                        }
                      }
                    }
                  }
                } else {
                  navigate("/login");
                }
              }}
              style={isCompactSlip ? {
                ...compactSlipStyles.placeButton,
                ...(isBookmaker || isMatchOdds ? { background: "linear-gradient(180deg, #6686b4 0%, #4f647e 100%)", color: "#e7efff" } : {}),
                cursor: compactSlipDisabled ? "not-allowed" : "pointer",
              } : undefined}
              disabled={isCompactSlip ? compactSlipDisabled :
                betSelectionObj?.oddsSelect == null ||
                betSelectionObj?.oddsSelect == ""
                  ? true
                  : disableCondition
              }
              className={isCompactSlip ? undefined :
                betSelectionObj?.bidPrice <= amountRange.max &&
                betSelectionObj?.bidPrice >= amountRange.min &&
                messageTab == false &&
                check &&
                betSelectionObj?.oddsSelect != null &&
                betSelectionObj?.oddsSelect != ""
                  ? "btn-send w-100"
                  : "btn-send w-100 disable"
              }
            >
              Place Bet
            </button>
          </li>
        </ul>
        {!isCompactSlip && betSelectionObj.betType !== "betFair" && (
          <div
            id="acceptAnyOddsBox"
            className="bet-setting"
            style={{ display: "flex" }}
          >
            <a
              id="acceptAnyOdds"
              href="javascript:void(0)"
              onClick={() => {
                if (!defaultOdds) {
                  setBetSelectionObj({
                    ...betSelectionObj,
                    expectany: !betSelectionObj.expectany,
                  });
                }
              }}
              className={
                betSelectionObj.expectany ? "bet-check checked" : "bet-check"
              }
            >
              Accept Any Odds
            </a>
            {/* <span id="sportsBookMaxStake" style={{ display: "flex" }}>
          <a id="getSportsBookMaxStakeBtn" className="max-bet" href="#">
            Max
          </a>
        </span> */}
          </div>
        )}
      </div>
      {/* {showElement ? (
        
      ) : (
        <></>
      )} */}
    </>
  );
};

const compactSlipStyles = {
  panel: {
    display: "grid", gap: "8px", width: "100%", boxSizing: "border-box",
    margin: 0, padding: "8px 4px 6px", background: "#d2edce",
    borderBottom: "1px solid #7e97a7", color: "#111",
    fontFamily: "Tahoma, Helvetica, sans-serif", lineHeight: 1,
  },
  twoColumns: { display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: "6px" },
  stepper: {
    display: "grid", gridTemplateColumns: "38px minmax(0, 1fr) 38px",
    height: "40px", minWidth: 0, overflow: "hidden", boxSizing: "border-box",
    background: "#fff", border: "1px solid #aaa", borderRadius: "7px",
  },
  stepButton: {
    display: "flex", alignItems: "center", justifyContent: "center",
    width: "100%", height: "100%", margin: 0, padding: 0, border: 0,
    background: "linear-gradient(180deg, #fff 0%, #ededed 100%)",
    boxShadow: "none", color: "#2676a8", fontFamily: "Arial, sans-serif",
    fontSize: "34px", fontWeight: 400, lineHeight: 1, cursor: "pointer",
  },
  disabledStep: { background: "transparent", color: "#6ca5bb", cursor: "default", opacity: 1 },
  value: {
    display: "flex", alignItems: "center", justifyContent: "center",
    width: "100%", minWidth: 0, height: "100%", boxSizing: "border-box",
    margin: 0, padding: 0, border: 0, borderRadius: 0, boxShadow: "none",
    background: "#fff", color: "#666", textAlign: "center",
    fontFamily: "Tahoma, Helvetica, sans-serif", fontSize: "16px", fontWeight: 700,
  },
  stakes: { display: "grid", gridTemplateColumns: "repeat(4, minmax(0, 1fr))", gap: "8px" },
  stakeButton: {
    display: "flex", alignItems: "center", justifyContent: "center",
    height: "31px", width: "100%", minWidth: 0, boxSizing: "border-box",
    margin: 0, padding: "0 2px", border: "1px solid #444", borderRadius: "4px",
    background: "#f8f8f8", boxShadow: "none", color: "#111",
    fontFamily: "Arial, sans-serif", fontSize: "14px", fontWeight: 400,
    lineHeight: 1, cursor: "pointer",
  },
  actions: {
    display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: "8px",
    margin: 0, padding: 0, listStyle: "none",
  },
  actionItem: { display: "block", width: "100%", minWidth: 0, margin: 0, padding: 0, listStyle: "none" },
  cancelButton: {
    display: "flex", alignItems: "center", justifyContent: "center",
    width: "100%", height: "38px", boxSizing: "border-box", margin: 0, padding: 0,
    border: "1px solid #444", borderRadius: "4px", background: "#f8f8f8",
    boxShadow: "none", color: "#000", fontFamily: "Tahoma, Helvetica, sans-serif",
    fontSize: "14px", fontWeight: 700, textDecoration: "none", lineHeight: 1, cursor: "pointer",
  },
  placeButton: {
    display: "flex", alignItems: "center", justifyContent: "center",
    width: "100%", height: "38px", boxSizing: "border-box", margin: 0, padding: 0,
    border: "1px solid #536977", borderRadius: "4px",
    background: "linear-gradient(180deg, #6e8eac 0%, #536a72 100%)",
    boxShadow: "none", color: "#fff", fontFamily: "Tahoma, Helvetica, sans-serif",
    fontSize: "16px", fontWeight: 700, lineHeight: 1, opacity: 1,
  },
  // ── Desktop horizontal layout ────────────────────────────────────────────
  desktopRow: {
    display: "grid",
    gridTemplateColumns: "minmax(150px, 1.3fr) minmax(170px, 1.2fr) minmax(170px, 1.2fr) minmax(150px, 1.3fr)",
    alignItems: "center", gap: "10px", width: "100%",
  },
  desktopStakes: {
    display: "grid", gridTemplateColumns: "repeat(8, minmax(0, 1fr))",
    gap: "8px", width: "100%",
  },
  desktopStakeButton: {
    display: "flex", alignItems: "center", justifyContent: "center",
    height: "28px", width: "100%", minWidth: 0, boxSizing: "border-box",
    margin: 0, padding: "0 2px", border: "1px solid #9fb6c4", borderRadius: "5px",
    background: "#fff", boxShadow: "none", color: "#111",
    fontFamily: "Arial, sans-serif", fontSize: "13px", fontWeight: 400,
    lineHeight: 1, cursor: "pointer",
  },
  desktopStepper: {
    display: "grid", gridTemplateColumns: "34px minmax(0, 1fr) 34px",
    height: "34px", minWidth: 0, overflow: "hidden", boxSizing: "border-box",
    background: "#fff", border: "1px solid #aaa", borderRadius: "6px",
  },
  desktopCancel: {
    display: "flex", alignItems: "center", justifyContent: "center",
    width: "100%", height: "34px", boxSizing: "border-box", margin: 0, padding: 0,
    border: "1px solid #444", borderRadius: "5px", background: "#fff",
    boxShadow: "none", color: "#000", fontFamily: "Tahoma, Helvetica, sans-serif",
    fontSize: "13px", fontWeight: 700, textDecoration: "none", lineHeight: 1, cursor: "pointer",
  },
  desktopPlace: {
    display: "flex", alignItems: "center", justifyContent: "center",
    width: "100%", height: "34px", boxSizing: "border-box", margin: 0, padding: 0,
    border: "1px solid #536977", borderRadius: "5px",
    background: "linear-gradient(180deg, #6686b4 0%, #4f647e 100%)",
    boxShadow: "none", color: "#e7efff", fontFamily: "Tahoma, Helvetica, sans-serif",
    fontSize: "14px", fontWeight: 700, lineHeight: 1, opacity: 1,
  },
};

export default Keyboard;
